/**
 * Promo bundles from the plan catalog carry both locales: `name` holds the
 * English copy and `namefr` the French. Records returned by
 * findAndValidatePromotions carry only the locale that was requested, and
 * normalizePlanByIdForLocale collapses `name` to the active locale for
 * mergeLocalizedPlanCopy — so not every record in the store has both.
 */
export const resolveBundleName = (bundle, lang) => {
  if (!bundle) return ''
  return lang === 'fr'
    ? (bundle?.namefr || bundle?.name || '')
    : (bundle?.name || bundle?.namefr || '')
}

/**
 * True when a bundle can be rendered in either language straight from the
 * store. Both fields must be present and different: a collapsed French record
 * ends up with `name` and `namefr` holding the same French string, which would
 * otherwise look bilingual and render French under English.
 *
 * A promo whose English and French copy are genuinely identical fails this
 * check and is re-validated instead — a wasted call, never wrong copy.
 */
export const carriesBothLocales = (promoInfo) => {
  const bundles = promoInfo?.bundles
  if (!Array.isArray(bundles) || bundles.length === 0) return false
  return bundles.every((bundle) => (
    Boolean(bundle?.name) && Boolean(bundle?.namefr) && bundle.name !== bundle.namefr
  ))
}
